import { ControlProps, isControl, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { formatNumber } from "../Grid/ValueFormatters";

const NumberRenderer = (props: ControlProps) => {
  const isEmpty =
    props.data === null || props.data === undefined || props.data === "";

  // formatNumber passes non-numeric input straight through, which is what the
  // grid's number column type does too.
  const text = isEmpty ? "" : String(formatNumber(props.data));

  return (
    <div className="control">
      <label>{props.label}</label>
      <div>
        <span>{text}</span>
      </div>
    </div>
  );
};

export const numberRendererTester = rankWith(100, (uischema) => {
  if (!isControl(uischema)) return false;
  return uischema.options?.variant === "number";
});

export default withJsonFormsControlProps(NumberRenderer);
